import { Section } from '@telegram-apps/telegram-ui';
import { TelegramTitle } from '../../components/shared/TelegramTitle';
import { GreenCardForm } from './GreenCardForm';
import { useLanguage } from '../../LanguageProvider';

export const GreenCard = () => {
  const { translate, setLanguage, language } = useLanguage();

  return (
    <>
      <div style={{ background: 'var(--tgui--secondary_bg_color)' }}>
        <TelegramTitle
          title={translate('green-card-form:title')}
          subtitle={translate('green-card-form:subtitle')}
        />
        {/* <Section className="m-2"> */}
        <GreenCardForm />
        {/* </Section> */}
      </div>
    </>
  );
};
